import React, { useState } from "react";
import "../styles/ContactUsPage.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactUsPage = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: ""
    });

    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/email/contact-us`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                toast.success("Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.", {
                    position: "top-right",
                    autoClose: 5000,
                });
                setFormData({
                    name: "",
                    email: "",
                    subject: "",
                    message: ""
                });
            } else {
                toast.error("Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.", {
                    position: "top-right",
                    autoClose: 5000,
                });
            }
        } catch (error) {
            toast.error("Bir hata oluştu. Lütfen daha sonra tekrar deneyin.", {
                position: "top-right",
                autoClose: 5000,
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="contact-page">
            {/* Hero Section */}
            <div className="contact-hero">
                <div className="hero-content">
                    <h1 className="hero-title">Bizimle İletişime Geçin</h1>
                    <h3> RSG Bilgi Teknolojileri Sağlık ve İnovasyon Hizmetleri Ltd. Şti. </h3>
                    <p className="hero-subtitle">
                        Sorularınız, önerileriniz veya iş birliği teklifleriniz için
                        bizimle iletişim kurmaktan çekinmeyin
                    </p>
                </div>
            </div>

            <div className="contact-container">
                {/* Contact Information Cards */}
                <div className="contact-info-section">
                    <div className="contact-cards">
                        <div className="contact-card">
                            <div className="card-icon">
                                <i className="fas fa-map-marker-alt"></i>
                            </div>
                            <h3>Adres</h3>
                            <p>
                                Marmara Üniversitesi<br/>
                                Teknoloji Fakültesi<br/>
                                34722 Kadıköy/İstanbul
                            </p>
                        </div>


                        <div className="contact-card">
                            <div className="card-icon">
                                <i className="fas fa-envelope"></i>
                            </div>
                            <h3>E-posta</h3>
                            <p>
                                info@meduvr.com
                            </p>
                        </div>

                    </div>
                </div>

                {/* Contact Form Section */}
                <div className="contact-form-section">
                    <div className="form-header">
                        <h2>Mesaj Gönderin</h2>
                        <p>Formu doldurarak bizimle iletişime geçebilirsiniz</p>
                    </div>

                    <form onSubmit={handleSubmit} className="contact-form">
                        <div className="form-row">
                            <div className="form-group">
                                <label htmlFor="name">
                                    <i className="fas fa-user"></i>
                                    Ad Soyad *
                                </label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    placeholder="Adınızı ve soyadınızı girin"
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="email">
                                    <i className="fas fa-envelope"></i>
                                    E-posta *
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    placeholder="E-posta adresinizi girin"
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="subject">
                                <i className="fas fa-tag"></i>
                                Konu *
                            </label>
                            <input
                                type="text"
                                id="subject"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                required
                                placeholder="Mesajınızın konusunu girin"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="message">
                                <i className="fas fa-comment"></i>
                                Mesaj *
                            </label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                rows="6"
                                placeholder="Mesajınızı buraya yazın..."
                            ></textarea>
                        </div>

                        <button
                            type="submit"
                            className={`submit-btn ${isLoading ? 'loading' : ''}`}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <i className="fas fa-spinner fa-spin"></i>
                                    Gönderiliyor...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-paper-plane"></i>
                                    Mesajı Gönder
                                </>
                            )}
                        </button>
                    </form>
                </div>

                {/* Map Section */}
                <div className="map-section">
                    <h2>Lokasyonumuz</h2>
                    <div className="map-container">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3014.7849441851944!2d29.139630315441454!3d40.954243879295166!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac55376173edf%3A0xe74ac53058d6453a!2sMarmara%20%C3%9Cniversitesi%20Teknopark!5e0!3m2!1str!2str!4v1704067200000!5m2!1str!2str"
                            width="100%"
                            height="400"
                            style={{ border: 0, borderRadius: '15px' }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Marmara Üniversitesi Teknopark - Maltepe"
                        ></iframe>
                    </div>
                </div>
            </div>

            <ToastContainer />
        </div>
    );
};

export default ContactUsPage;
